import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/eventClass/importer/eventClassImporterActions';

export default importerReducers(actions);
